import APP_ASSETS from "@/assets";
import { InputType } from "./input.type";
import "./input.css";

export const Input: React.FC<InputType> = ({
  label,
  value,
  type,
  name,
  onChange,
  placeholder,
  errorText,
  isError,
  rightComponent,
}) => {
  return (
    <div>
      <div className="mb-1 flex items-center justify-between">
        {label && (
          <label
            className="font-satoshiBold text-[14px] tracking-wide text-text-primary"
            htmlFor="address">
            {label}
          </label>
        )}
        {rightComponent && rightComponent()}
      </div>
      <input
        className="font-satoshiMedium w-full rounded-md border border-gray-800 bg-white p-2 text-sm tracking-wider text-black outline-none"
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      {isError && (
        <div className={"mt-1 flex h-3 items-center gap-1"}>
          {errorText && (
            <div className="input-error-fade-in flex items-center">
              <img
                className="mr-1 h-3 w-3"
                src={APP_ASSETS.ICONS.ERROR_INFO}
                alt="errorInfo"
              />
              <p className="text-xs text-red-500">{errorText}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
